import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { CCMCConfirmDialogComponent } from '../../../@ccmc/components/confirm-dialog/confirm-dialog.component';

@NgModule({
    declarations: [
        CCMCConfirmDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    entryComponents: [
        CCMCConfirmDialogComponent
    ],
})
export class CCMCConfirmDialogModule {
}
